var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.861,
    height: 14.852,
    viewBox: "0 0 14.861 14.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2352",
    "data-name": "Group 2352",
    transform: "translate(7779.283 11742.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M280.455,167.483h-5.367c-.014,0-.028,0-.042,0h0a2.113,2.113,0,0,0-2.107,2.107v5.323a2.113,2.113,0,0,0,2.107,2.107h.085A2.027,2.027,0,0,0,277.153,175v-3.3h3.216a2.113,2.113,0,0,0,2.107-2.107V169.5A2.027,2.027,0,0,0,280.455,167.483Z",
    transform: "translate(-8046.898 -11904.446)",
    fill: "#54c1bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M271.768,158.892h-.086a2.027,2.027,0,0,0-2.021,2.021v3.3h-3.216a2.113,2.113,0,0,0-2.107,2.107v.086a2.027,2.027,0,0,0,2.021,2.021h5.366c.015,0,.028,0,.043,0a2.113,2.113,0,0,0,2.107-2.107V161A2.113,2.113,0,0,0,271.768,158.892Z",
    transform: "translate(-8043.62 -11901.174)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M275.046,167.479a2.113,2.113,0,0,0-2.107,2.107V171.7H275c.015,0,.028,0,.043,0a2.113,2.113,0,0,0,2.107-2.107v-2.112h-2.065C275.074,167.483,275.06,167.479,275.046,167.479Z",
    transform: "translate(-8046.898 -11904.446)",
    fill: "#04496b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a585e2eb.svg";
export { ForwardRef as ReactComponent };